import { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import styles from './style.module.scss'

const CountdownTimer = ({ targetDate = '2025-03-22T19:30:00+05:30', isMweb = false }) => {
  const calculateTimeLeft = () => {
    const difference = +new Date(targetDate) - +new Date()
    let timeLeft = {}

    if (difference > 0) {
      timeLeft = {
        days: Math.floor(difference / (1000 * 60 * 60 * 24)),
        hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
        minutes: Math.floor((difference / 1000 / 60) % 60),
        seconds: Math.floor((difference / 1000) % 60)
      }
    } else {
      timeLeft = {
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0
      }
    }

    return timeLeft
  }

  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft())

  const [isTimeUp, setIsTimeUp] = useState()
  useEffect(() => {
    const timer = setTimeout(() => {
      setTimeLeft(calculateTimeLeft())
    }, 1000)
    setIsTimeUp(timeLeft.days === 0 && timeLeft.hours === 0 && timeLeft.minutes === 0 && timeLeft.seconds === 0)
    return () => clearTimeout(timer)
  }, [timeLeft])

  return (
    <div className={`${styles.countdown} ${isTimeUp ? isMweb ? 'd-none' : 'invisible' : ''}`}>
      <div className='d-flex flex-column align-items-center'>
        <div className={styles.countdownItem}>
          {timeLeft.days || '0'}
        </div>
        <div className={styles.time}>Days</div>
      </div>
      <div className='d-flex flex-column align-items-center'>
        <div className={styles.countdownItem}>
          {timeLeft.hours || '0'}
        </div>
        <div className={styles.time}>Hrs</div>
      </div>
      <div className='d-flex flex-column align-items-center'>
        <div className={styles.countdownItem}>
          {timeLeft.minutes || '0'}
        </div>
        <div className={styles.time}>Min</div>
      </div>
      <div className='d-flex flex-column align-items-center'>
        <div className={styles.countdownItem}>
          {timeLeft.seconds || '0'}
        </div>
        <div className={styles.time}>Sec</div>
      </div>
    </div>
  )
}

export default CountdownTimer

CountdownTimer.propTypes = {
  targetDate: PropTypes.any,
  isMweb: PropTypes.bool
}
